<template>
  <g
    id="Rear_Right_Indocator"
    v-on:click="changeSeverity('rearRightIndicator')"
    :class="severityClass"
  >
    <rect class="cls-896" x="48.52" y="280.36" width="9.27" height="2.23" />
    <g>
      <circle
        class="cls-208"
        cx="45.31"
        cy="281.48"
        r="5.2"
        transform="translate(-69.78 20.64) rotate(-14.66)"
      />
      <circle
        class="cls-458"
        cx="45.31"
        cy="281.48"
        r="5.09"
        transform="translate(-69.73 20.62) rotate(-14.65)"
      />
      <circle
        class="cls-170"
        cx="45.31"
        cy="281.48"
        r="4.98"
        transform="translate(-69.67 20.59) rotate(-14.64)"
      />
      <circle
        class="cls-300"
        cx="45.31"
        cy="281.48"
        r="4.87"
        transform="translate(-69.6 20.56) rotate(-14.62)"
      />
      <circle
        class="cls-135"
        cx="45.31"
        cy="281.48"
        r="4.76"
        transform="translate(-69.49 20.51) rotate(-14.6)"
      />
      <circle
        class="cls-301"
        cx="45.31"
        cy="281.48"
        r="4.65"
        transform="translate(-69.33 20.44) rotate(-14.57)"
      />
      <circle class="cls-403" cx="45.31" cy="281.48" r="4.54" />
      <circle class="cls-363" cx="45.31" cy="281.48" r="4.43" />
      <circle class="cls-364" cx="45.31" cy="281.48" r="4.32" />
      <circle class="cls-31" cx="45.31" cy="281.48" r="4.22" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
